import React, { forwardRef, useEffect, useState } from "react";
import SortableTree, { addNodeUnderParent, removeNodeAtPath, changeNodeAtPath } from '@nosferatu500/react-sortable-tree';
import Modal from '../../Modal/CustomModal';
import { Button, Row, Col } from 'reactstrap';
import { Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import '@nosferatu500/react-sortable-tree/style.css';
import SortableTreeForm from './SortableTreeFormTutorial';
import Toast from './../../Toast/Toast';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import classNames from 'classnames';
import './SortableTreeTutorial.css';
import CustomNodeRenderer from './CustomSortableTreeNode/node-renderer-default.tsx';

const Tree = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const sessionKey = 'core-sorteable-data-' + props.name;

  const getNodeKey = ({ treeIndex }) => treeIndex;
  const defaultProps = {
    value: [{ title: props.labelNewItem ? props.labelNewItem : 'Novo Item' }],
    levelsLimit: 2,
    labelNewItem: 'Novo Item',
    labelTitleModal: 'Editar Item',
    afterSubmit: (treeData) => {},
    wrapTitle: (item) => item.title,
  };

  props = { ...defaultProps, ...props };

  let addIdsTree = (tree) => {
    return tree.map((node) => {
      node._id = node._id ? node._id : uuid();
      if (node.children) {
        node.children = addIdsTree(node.children);
      }
      return node;
    });
  };

  let [treeData, setTreeData] = useState(
    props.value ? addIdsTree(props.value) : addIdsTree(defaultProps.value)
  );
  dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: treeData });

  let [showModal, setShowModal] = useState('');
  let [modalTitle, setModalTitle] = useState(props.labelTitleModal);
  let [modalContent, setModalContent] = useState('');
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const deleteModalTitle = "Excluir";
  const [deleteModalContent, setDeleteModalContent] = useState('');

  const handleChange = (treeData) => {
    setTreeData(treeData);

    props.onChange({
      target: {
        name: props.name,
        value: treeData,
      },
    });
    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: treeData });
  };

  const handleSubmit = async (fields, values, currentNode) => {
    Toast.success('Informações atualizadas com sucesso!');
    const path = currentNode.path;
    currentNode.node = { ...currentNode.node, ...values };
    let tempTreeData = changeNodeAtPath({
      treeData: treeData,
      path,
      getNodeKey,
      newNode: currentNode.node,
      expandParent: true,
    });
    setTreeData(tempTreeData);
    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: tempTreeData });
    setShowModal(false);
  };

  const loadForm = (node, type) => {
    return (
      <div style={{ minHeight: 390 }}>
        <SortableTreeForm
          customValidators={props.customValidators}
          fields={type !== "child" ? props.fields : props.childFieldsForm}
          values={node.node}
          handleSubmit={handleSubmit}
          currentNode={node}
        />
      </div>
    );
  };

  useEffect(() => {
    props.onChangeTreeData(treeData);
  }, [treeData]);

  function handleDeleteItem(treeData) {
    setTreeData(treeData);
    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: treeData });
  };

  const loadDeleteContent = (info, type) => {
    return (
      <div>
        <p className="py-2 text-dark" style={{ fontWeight: '500' }}>
          Tem certeza de que deseja excluir este {type !== "child" ? "módulo" : "tutorial"}?
        </p>
        <div 
          className="modal-footer" 
          onClick={() => setShowDeleteModal(false)}
        >
          <button className="btn btn-secondary mr-2" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={() => handleDeleteItem(info)}>
            Confirmar
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={classNames('custom_node', props.customStyles)} style={{ height: 400 }} ref={ref}>
      <SortableTree
        treeData={treeData}
        onChange={(treeData) => handleChange(treeData)}
        generateNodeProps={({ node, path }) => {
          let title = node.title;
          if (props.wrapTitle) {
            title = props.wrapTitle(node);
          }
          return {
            title: <div>{title}</div>,
            buttons: [
              <a
                className="btn btn-primary btn-sm btn-action"
                onClick={() => {
                  if (path.length <= props.levelsLimit) {
                    let tempTreeData = addNodeUnderParent({
                      treeData: treeData,
                      parentKey: path[path.length - 1],
                      expandParent: true,
                      getNodeKey,
                      newNode: {
                        nodeKey: getNodeKey,
                        title: props.labelNewItem,
                        _id: uuid(),
                      },
                    }).treeData;
                    setTreeData(tempTreeData);
                    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: tempTreeData });
                  } else {
                    Toast.error('Limite de níveis atingido!');
                  }
                }}
              >
                <i className="fas fa-plus"></i>
              </a>,
              <a
                className="btn btn-info btn-sm btn-action"
                onClick={() => {
                  const isChild = path[1] != undefined;
                  setShowModal(true);
                  let info = {
                    data: treeData,
                    node: node,
                    path: path,
                    getNodeKey: getNodeKey,
                  };
                  setModalContent(loadForm(info, isChild ? "child" : "parent"));
                }}
              >
                <i className="fas fa-pencil-alt"></i>
              </a>,
              <a
                className="btn btn-danger btn-sm btn-action"
                onClick={() => {
                  if (node.children && node.children.length > 0) {
                    Toast.error('Não é possível excluir um item que possua itens relacionados');
                  } else if (treeData[0]._id === node._id && treeData.length === 1) {
                    Toast.error('Não é possível excluir o primeiro item.');
                  } else {
                    const isChild = path[1] != undefined;
                    setShowDeleteModal(true);
                    let info = removeNodeAtPath({
                      treeData: treeData,
                      path,
                      getNodeKey,
                    });
                    setDeleteModalContent(loadDeleteContent(info, isChild ? "child" : "parent"));
                  }
                }}
              >
                <i className="fas fa-trash"></i>
              </a>,
            ],
          };
        }}
        nodeContentRenderer={CustomNodeRenderer}
        maxDepth={2}
      />
      <Modal
        show={showModal}
        showButtons={false}
        handleShow={() => setShowModal(true)}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => setShowModal(true)}
        handleCancel={() => setShowModal(false)}
        title={modalTitle}
        content={modalContent}
      />
      <Modal
        show={showDeleteModal}
        showButtons={false}
        handleShow={() => setShowDeleteModal(true)}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={() => setShowDeleteModal(true)}
        handleCancel={() => setShowDeleteModal(false)}
        title={deleteModalTitle}
        content={deleteModalContent}
      />
    </div>
  );
});

export default Tree;
